import { createStore, applyMiddleware, compose } from "redux";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { syncFeaturesWithStore } from "shared/features";
import { syncInfoWithStore } from "shared/storeInfo";
import config from "shared/config";

import defaultReduxMiddlewares from "shared/redux-store/defaultReduxMiddleware";

const defaultMiddlewares = defaultReduxMiddlewares();

export const emptyState = {
  app: {
    currentPageData: {},
    locale: "de",
    isFetching: true,
    features: {},
    account: {},
  },
  data: {},
};

export const defaultStoreState = (initialState, state) => {
  // Manually iterating state keys. Please use a deep merge when this
  // gets more complex
  return {
    ...initialState,
    app: {
      ...state.app,
      ...(initialState ? initialState.app : {}),
    },
    data: {
      ...state.data,
      ...(initialState ? initialState.data : {}),
    },
  };
};

export function defaultConfigureStore(
  rootReducer,
  initialState = {},
  extraMiddlewares = [],
) {
  // Build middleware stack
  const middleware = applyMiddleware(
    ...defaultMiddlewares,
    ...extraMiddlewares,
  );

  // Browser redux-dev-tools

  /* eslint-disable */
  const composeEnhancers =
    config.clientEnv === "development"
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
      : compose;
  /* eslint-enable */

  // Create Actual Store & Syncs
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(middleware),
  );
  syncHistoryWithStore(browserHistory, store);
  syncFeaturesWithStore(store);
  syncInfoWithStore(store);

  return store;
}
